import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=28222a15&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=js&"
export * from "./Round.vue?vue&type=script&lang=js&"
import style0 from "./Round.vue?vue&type=style&index=0&id=28222a15&prod&scoped=true&lang=less&"
import style1 from "./Round.vue?vue&type=style&index=1&id=28222a15&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28222a15",
  null
  
)

export default component.exports